import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const isLoggedIn = useSelector((state) => state.auth.authenticated);
  return isLoggedIn ? <Outlet /> : <Navigate to="/admin" />;
};

export default PrivateRoute;
